const currencySymbols = {
  RUB: '₽',
  UAH: '₴',
  USD: '$',
  KZT: '₸',
  BYR: 'Br',
  EUR: '€',
  BYN: 'Br',
  MNT: '₮',
  MDL: 'L',
  LKR: '₹',
  CNY: '¥',
  CHF: '₣',
  GBP: '£',
  TRY: '₺',
  MXN: 'MXN',
  EMPTY: ''
}
export default {
  methods: {
    currencySymbol (currency = 'RUB') {
      if (currency === null || currency === '') {
        currency = 'EMPTY'
      }

      return currencySymbols[currency] ? currencySymbols[currency] : currency
    }
  }
}
